import React, { useState, useEffect } from "react";
import axios from "axios";

const QuerySection = () => {
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLatestQueries = async () => {
      try {
        setLoading(true);
        setError(null);

        const token = localStorage.getItem("facultyToken"); // or whatever key you use

        const response = await axios.get("https://admin.stipsredu.in/api/query/latest", {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        });

        // If your backend returns array directly → response.data
        // If it returns { queries: [...] } or { data: [...] } → adjust accordingly
        const data = Array.isArray(response.data)
          ? response.data
          : response.data?.queries || response.data?.data || [];

        setQueries(data);
      } catch (err) {
        console.error("Failed to fetch queries:", err);
        setError(
          err.response?.data?.message ||
            "Could not load recent queries. Please try again later."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchLatestQueries();
  }, []);

  return (
    <div className="p-6 bg-white rounded-xl shadow-md">
      <h2 className="text-2xl font-bold text-[#112E65] mb-6">Faculty Queries</h2>

      {loading ? (
        <div className="text-center py-10 text-gray-500">
          Loading latest queries...
        </div>
      ) : error ? (
        <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6 text-red-700 rounded">
          {error}
          <button
            onClick={() => window.location.reload()}
            className="ml-3 underline font-medium hover:text-red-800"
          >
            Refresh
          </button>
        </div>
      ) : queries.length === 0 ? (
        <div className="text-center py-10 text-gray-600 bg-gray-50 rounded-lg">
          <p className="text-lg">No recent queries found.</p>
          <p className="mt-2 text-sm">The most recent 12 queries will appear here.</p>
        </div>
      ) : (
        <div className="space-y-5">
          {queries.map((query) => (
            <div
              key={query._id}
              className="p-5 border border-gray-200 rounded-lg hover:shadow-md transition-shadow"
            >
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h3 className="font-semibold text-[#112E65]">
                    {query.facultyName || "Unknown Faculty"}
                  </h3>
                  <p className="text-sm text-gray-500">
                    {query.facultyId} • {query.department}
                  </p>
                </div>

                <span
                  className={`px-3 py-1 text-xs font-medium rounded-full ${
                    query.status === "pending"
                      ? "bg-yellow-100 text-yellow-800"
                      : query.status === "replied"
                      ? "bg-green-100 text-green-800"
                      : "bg-gray-200 text-gray-700"
                  }`}
                >
                  {query.status?.charAt(0).toUpperCase() + query.status?.slice(1) ||
                    "Pending"}
                </span>
              </div>

              <p className="text-gray-700 mb-3">{query.message}</p>

              <div className="text-xs text-gray-500 flex justify-between">
                <span>
                  Submitted: {new Date(query.createdAt).toLocaleDateString()}
                </span>
                {query.repliedAt && (
                  <span>
                    Replied: {new Date(query.repliedAt).toLocaleDateString()}
                  </span>
                )}
              </div>

              {query.reply && (
                <div className="mt-4 pt-3 border-t border-gray-200">
                  <p className="text-sm font-medium text-gray-600">Reply:</p>
                  <p className="mt-1 text-gray-800">{query.reply}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuerySection;